import React, { FC, ReactElement, useEffect, useState } from "react";
import Modal from 'react-modal';
import { useLocale } from "../../contexts/localeContext";
import NotificationTypeStep from "./notification-type-step";
import WizardSideBarStep from "../../models/WizardSideBarStep";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import ScheduleModal from "./schedule/schedule-modal";
import EventBasedModal from "./event-based/event-based-modal";
import { SCHEDULE_NOTIFICATION_TYPE_ID, EVENT_BASED_NOTIFICATION_TYPE_ID  } from "../../constants/notification-key";
import NotificationWizard from "./notification-wizard";

type Props = {
    onClose: () => void;
    isOpen: boolean;
}

const WizardNotification:FC<Props> = ({ onClose, isOpen }) => {
    const { translate } = useLocale();
    const [taskId, setTaskId] = useState<string>("");
    const [taskDescription, setTaskDescription] = useState<string>(translate.byKey(TranslationKeys.pending));
    const [hideMainModal, setHideMainModal] = useState<boolean>(false);

    useEffect(() => {
        if (!isOpen) {
            resetKeyField();
        }
    }, [isOpen])

    const resetKeyField = () => {
        setTaskId("");
        setTaskDescription(translate.byKey(TranslationKeys.pending));
    }

    const getWizard = () => {
        if (taskId === SCHEDULE_NOTIFICATION_TYPE_ID) {
            return (
                <ScheduleModal
                    onClose={onClose}
                    defaultSteps={steps}
                    onBack={resetKeyField}
                    defaultContent={content} />
            )
        } else if (taskId === EVENT_BASED_NOTIFICATION_TYPE_ID) {
            return (
                <EventBasedModal
                    onClose={onClose}
                    defaultSteps={steps}
                    onBack={resetKeyField}
                    defaultContent={content}
                    setHideMainModal={setHideMainModal} />
            )
        } else {
            return (
                <NotificationWizard
                    name={translate.byKey(TranslationKeys.notification)}
                    step={0}
                    onClose={onClose}
                    sidebarSteps={steps}
                    stepContent={content} />
            );

        }
    }

    const onDetailsNext = (event: any) => {
        if(event.task) {
            setTaskId(event.id);
            setTaskDescription(event.task);
        }
    }

    const content:ReactElement[] = [
        <NotificationTypeStep  onNext={onDetailsNext} setDescription={setTaskDescription} />
    ]

    const steps: WizardSideBarStep[] = [
        {
            title: translate.byKey(TranslationKeys.type),
            description: taskDescription,
            substeps: []
        }
    ];

    return (
        <Modal isOpen={isOpen}
            ariaHideApp={false}
            overlayClassName={`flex w-screen position-float fixed top-0 left-0 h-screen bg-opacity-75 bg-white ${hideMainModal ? 'hidden' : ''}`}
            className={`bg-white border-none m-auto shadow select-none outline-none w-content ${hideMainModal ? 'hidden' : ''}`}>
            {getWizard()}
        </Modal>
    )
}

export default WizardNotification;
